module.exports = __webpack_public_path__ + "img/incein-circle-4.c72f3089.svg";